import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchSubprocessen'
import type { SubprocessenSearch } from '../types/SubprocessenSearch'

export { useSubprocessenSearchStore }

const useSubprocessenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<SubprocessenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
